// src/hooks/useProfesores.ts
import { useMemo } from "react";
import { useUsuarios, Usuario } from "./useUsuarios";

export interface Profesor extends Usuario {
  rol: "profesor";
  /** alias útil para MUI Autocomplete */
  nombre: string;
}

/**
 * Devuelve profesores. Por defecto SOLO activos.
 * Si quisieras incluir inactivos puntualmente: useProfesores({ soloActivos: false })
 */
export function useProfesores(opts: { soloActivos?: boolean } = {}) {
  const { soloActivos = true } = opts;

  // Pide al backend ya filtrado: ?rol=profesor&activo=true (si soloActivos)
  const { rows, loading, error, refresh } = useUsuarios({
    rol: "profesor",
    soloActivos,
    auto: true,
  });

  const profesores = useMemo<Profesor[]>(
    () =>
      rows
        .filter((u) => u.rol === "profesor") // respaldo
        .map((u) => ({
          ...u,
          nombre: u.nombreCompleto ?? u.email,
        })) as Profesor[],
    [rows]
  );

  return { rows: profesores, loading, error, refresh };
}
